import { render, staticRenderFns } from "./Persons.vue?vue&type=template&id=06cc9e5b&scoped=true"
import script from "./Persons.vue?vue&type=script&lang=js"
export * from "./Persons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc9e5b",
  null
  
)

export default component.exports